/**
 * Dialog module dimension enum
 */
export type DialogDimension = 'large' | 'medium' | 'small';

/**
 * Dialog module dimension enum
 */
export enum DialogDimensions {
  /** Represents a large-sized dialog box, which is typically used for displaying large amounts of content or complex workflows that require more space. */
  Large = 'large',

  /** Represents a medium-sized dialog box, which is typically used for displaying moderate amounts of content or workflows that require less space. */
  Medium = 'medium',

  /** Represents a small-sized dialog box, which is typically used for displaying simple messages or workflows that require minimal space.*/
  Small = 'small',
}
